export const HTTPMethod = {
    get: 'GET',
    post: 'POST',
    patch: 'PATCH',
    put: 'PUT',
    delete: 'DELETE',
};
